import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const GUIDES = {
  '/dashboard': [
    'This page shows income, expenses, and net worth.',
    'Accounts holds the bank or cash account.',
    'Transactions holds money in and money out.',
    'Open any page for a short guide.'
  ],
  '/transactions': ['Money in and money out for this location.'],
  '/budgets': ['A plan for money in and money out.'],
  '/categories': ['Groups for money in and money out.'],
  '/subscriptions': ['Bills that repeat.'],
  '/billing': ['The payment for using eloNest. It is not the bills you track for a person or business.'],
  '/recurring-bills': ['Bills that come due on a schedule.'],
  '/accounts': ['Bank and cash accounts for this location.'],
  '/assets': ['Things this location owns.'],
  '/asset-expenses': ['Costs tied to something this location owns.'],
  '/customers': ['People and companies that pay this location.'],
  '/accounts-receivable': ['Money this location is waiting to receive.'],
  '/quotes': ['A price offered to a customer.'],
  '/accounts-payable': ['Bills this location still owes.'],
  '/inventory': ['Items this location keeps.'],
  '/settings': ['Sign-in and preferences.'],
  '/vehicles': ['Vehicles this location owns.'],
  '/properties': ['Property this location owns.'],
  '/creditors': ['People and companies this location owes.'],
  '/business': ['The name and details of this location.'],
  '/staff': ['People who work at this location.'],
  '/payroll': ['Pay for the people who work here.'],
  '/resolution-letters': ['A letter for a bill or an account.'],
  '/schedules': ['Dates and times for this location.'],
  '/reconciliation': ['Match the books to the bank.'],
  '/tasks': ['Work still to do for this location.'],
  '/reports': ['A summary of the books.']
};

export default function PageGuide() {
  const { pathname } = useLocation();
  const steps = GUIDES[pathname] || ['A short guide for this page.'];
  const [open, setOpen] = useState(true);
  const [step, setStep] = useState(0);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    setStep(0);
    setOpen(true);
    const check = () => setHidden(Boolean(document.querySelector('[data-empty-start]')));
    check();
    const soon = setTimeout(check, 50);
    const later = setTimeout(check, 400);
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      clearTimeout(soon);
      clearTimeout(later);
      observer.disconnect();
    };
  }, [pathname]);

  if (hidden) return null;

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => { setStep(0); setOpen(true); }}
        className="fixed bottom-4 right-4 z-40 px-3 py-2 bg-white border border-gray-200 rounded-full shadow text-sm text-gray-800"
      >
        Guide
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-40 w-72 bg-white border border-gray-200 rounded-lg shadow-lg p-4">
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm text-gray-800">{steps[step]}</p>
        <button type="button" onClick={() => setOpen(false)} className="text-gray-500 text-sm" aria-label="Close guide">
          Close
        </button>
      </div>
      {steps.length > 1 && (
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-gray-500">{step + 1} / {steps.length}</span>
          <button
            type="button"
            onClick={() => setStep((current) => (current + 1) % steps.length)}
            className="text-sm text-blue-700"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
